// store/vesselsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const portsSlice = createSlice({
  name: "ports",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    setPorts(state, action) {
      state.data = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    clearPorts(state) {
      state.data = [];
    },
  },
});

export const { setPorts, setLoading, setError, clearPorts } =
  portsSlice.actions;

export default portsSlice.reducer;
